/**
 * @modukle Import
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ChartType } from '@models/chart.model';
import { ChartsIcons } from '@functions/chart.functions';

@Component({
  selector: 'app-import-option',
  templateUrl: './import-option.component.html',
  styleUrls: ['./import-option.component.css']
})
export class ImportOptionComponent {

  @Input() label: string;
  @Input() color: string = ItemColor('indicators');
  @Input() sublabel: string;
  @Input() categories: string[];
  @Input() information: string;
  @Input() subinformation: string;
  @Input() dark: number = 5;
  @Input() limitedTo: ChartType[] = [];

  icons = ChartsIcons();

  constructor() {}

}
